export default {
  VALUE_TYPE: [
    { KEY: 'FIXED_VALUE', VALUE: 'R$', SIMBOL: 'R$' },
    { KEY: 'PERCENTAGE', VALUE: 'Porcentagem %', SIMBOL: '%' },
  ],
  VALUE_TYPE_FEE: [
    { KEY: 0, VALUE: 'Valor Fixo (R$)' },
    { KEY: 1, VALUE: 'Porcentagem %' },
  ],
  FARE_TAX_TYPE: [
    { KEY: 'FIXED_VALUE', VALUE: 'Valor Fixo' },
    { KEY: 'KM_VALUE', VALUE: 'Valor por Kilometragem' },
  ],
  OPERATION_VALUES: [
    { KEY: 'ADD', VALUE: 'Acréscimo' },
    { KEY: 'REMOVE', VALUE: 'Decréscimo' },
  ],
  PAYMENT_TYPES: [
    {
      KEY: 'TRANSPORT_CARD',
      VALUE: 'Cartão de transporte',
      NAME: 'transport-card',
    },
    { KEY: 'BUTTON', VALUE: 'Dinheiro', NAME: 'button' },
    { KEY: 'TOKEN', VALUE: 'Bipay', NAME: 'bipay' },
    { KEY: 'EMV', VALUE: 'EMV (cartões bancários)', NAME: 'emv' },
  ],
  WEEK_DAYS: [
    {
      KEY: 'MONDAY',
      VALUE: 'Segunda',
    },
    {
      KEY: 'TUESDAY',
      VALUE: 'Terça',
    },
    {
      KEY: 'WEDNESDAY',
      VALUE: 'Quarta',
    },
    {
      KEY: 'THURSDAY',
      VALUE: 'Quinta',
    },
    {
      KEY: 'FRIDAY',
      VALUE: 'Sexta',
    },
    {
      KEY: 'SATURDAY',
      VALUE: 'Sábado',
    },
    {
      KEY: 'SUNDAY',
      VALUE: 'Domingo',
    },
    {
      KEY: 'HOLIDAY',
      VALUE: 'Feriado',
    },
  ],
  VEHICLE_TYPES: [
    { KEY: 'MOTORCYCLE', VALUE: 'Motocicleta' },
    { KEY: 'CAR', VALUE: 'Auto pequeno' },
    { KEY: 'WHEELBARROW', VALUE: 'Carro de mão' },
    { KEY: 'TRAILER', VALUE: 'Reboque' },
    { KEY: 'LIGHTTRUCK', VALUE: 'Caminhão Simples' },
    { KEY: 'MEDIUMTRUCK', VALUE: 'Caminhão Truncado' },
    { KEY: 'HEAVYTRUCK', VALUE: 'Caminhão Pesado' },
    { KEY: 'HEAVYCAR', VALUE: 'Auto grande' },
    { KEY: 'BIKE', VALUE: 'Bicicleta' },
    { KEY: 'BUS', VALUE: 'Ônibus' },
    { KEY: 'LIGHTBUS', VALUE: 'Micro-ônibus' },
    { KEY: 'TRICYCLE', VALUE: 'Triciclo | Quadriciclo' },
  ],
  INTEGRATION_SYSTEMS: [{ KEY: 'W2I', VALUE: 'W2I' }],
};
